/**
 * File Name          : choose-unit.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';
import { DatasnapUnit, UNITS } from '../../models/lessons.model';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { VersionService } from '../../services/version.service';
import { ScreenserviceService } from '../../services/screenservice.service';

@Component({
  selector: 'app-choose-unit',
  standalone: true,
  imports: [DxButtonModule, CommonModule],
  templateUrl: './choose-unit.component.html',
  styleUrl: './choose-unit.component.scss'
})
export class ChooseUnitComponent {
  lessons: DatasnapUnit[] = [];
  appVersion: string = '';
  constructor(private router: Router, public screenservice: ScreenserviceService) {
    this.lessons = UNITS;
    
  }

  openLesson = (lesson: DatasnapUnit) => {
    this.router.navigate(['/home', lesson.id]);
  }
}
